module.exports = __webpack_public_path__ + "resources/img/zoom_server_sdk_authentication_flow.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom_server_sdk_authentication_flow.png
// module id = 1272
// module chunks = 0